export default __webpack_public_path__ + "static/LOGO_KA_gold-01-47602a15c4fffeaa61faf5ed9b7ad6db.jpg";